import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import humanTime from 'flarum/common/helpers/humanTime';
import extractText from 'flarum/common/utils/extractText';
import lang from '../common/languageName';
const t = (key, params) => app.translator.trans('ernestdefoe-flarumverse.forum.directory.' + key, params);
const topicName = key => app.translator.trans('ernestdefoe-flarumverse.lib.topics.' + key);
const languageName = code => lang(code, app.translator.getLocale(), extractText(t('several_languages')));
/** /forums: the Flarumverse directory (only on the forum that hosts it). */
export default class DirectoryPage extends Page {
  forums = [];
  topics = [];
  languages = [];
  topic = '';
  language = '';
  q = '';
  more = false;
  loading = true;
  broken = new Set();
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('flarumverse.directory', extractText(t('title')));
    app.setTitle(extractText(t('title')));
    this.load(true);
  }
  load(reset) {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/flarumverse/directory',
      params: {
        topic: this.topic,
        language: this.language,
        q: this.q,
        offset: reset ? 0 : this.forums.length
      }
    }).then(res => {
      this.forums = reset ? res.forums : this.forums.concat(res.forums);
      this.topics = res.topics;
      this.languages = res.languages;
      this.more = res.more;
    }, () => {}).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  topicOptions() {
    const options = {
      '': t('all_topics')
    };
    this.topics.forEach(k => options[k] = topicName(k));
    return options;
  }
  languageOptions() {
    const options = {
      '': t('all_languages')
    };
    this.languages.forEach(k => options[k] = languageName(k));
    return options;
  }
  filter(change) {
    change();
    this.load(true);
  }
  view() {
    return m(PageStructure, {
      className: "FlarumverseDirectory",
      sidebar: () => m(IndexSidebar, null)
    }, m("p", {
      className: "FlarumverseDirectory-intro"
    }, t('intro')), m("div", {
      className: "FlarumverseDirectory-filters"
    }, m("input", {
      className: "FormControl",
      type: "search",
      "aria-label": extractText(t('search')),
      placeholder: extractText(t('search')),
      value: this.q,
      oninput: e => {
        this.q = e.target.value;
        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.load(true), 300);
      }
    }), m(Select, {
      className: "FlarumverseDirectory-select",
      options: this.topicOptions(),
      value: this.topic,
      onchange: value => this.filter(() => this.topic = value)
    }), m(Select, {
      className: "FlarumverseDirectory-select",
      options: this.languageOptions(),
      value: this.language,
      onchange: value => this.filter(() => this.language = value)
    })), !this.loading && !this.forums.length ? m(Placeholder, {
      text: t('empty')
    }) : null, m("ul", {
      className: "FlarumverseDirectory-grid"
    }, this.forums.map(f => m("li", {
      key: f.id,
      className: "FlarumverseForum"
    }, m("a", {
      className: 'FlarumverseForum-banner is-' + (f.logoBg?.startsWith('#') ? 'brand' : f.logoBg || 'light'),
      href: f.url,
      rel: "noopener ugc",
      tabindex: "-1",
      "aria-hidden": "true",
      style: f.logoBg?.startsWith('#') ? {
        background: f.logoBg
      } : undefined
    }, (f.logo || f.icon) && !this.broken.has(f.id) ? m("img", {
      src: f.logo || f.icon,
      alt: "",
      loading: "lazy",
      decoding: "async",
      referrerpolicy: "no-referrer",
      className: f.logo ? 'FlarumverseForum-logo' : 'FlarumverseForum-icon',
      onerror: () => {
        this.broken.add(f.id);
        m.redraw();
      }
    }) : m("span", {
      className: "FlarumverseForum-initial"
    }, Array.from(f.name.trim())[0]?.toUpperCase())), m("div", {
      className: "FlarumverseForum-body"
    }, m("a", {
      className: "FlarumverseForum-name",
      href: f.url,
      rel: "noopener ugc"
    }, f.name), m("span", {
      className: "FlarumverseForum-host"
    }, f.url.replace(/^https:\/\//, '')), f.description ? m("p", {
      className: "FlarumverseForum-description"
    }, f.description) : null, m("div", {
      className: "FlarumverseForum-chips"
    }, m("span", null, topicName(f.topic)), m("span", null, languageName(f.language))), m("div", {
      className: "FlarumverseForum-stats"
    }, m("span", null, m(Icon, {
      name: "fas fa-user"
    }), " ", t('members', {
      count: f.members
    })), m("span", null, m(Icon, {
      name: "far fa-comments"
    }), " ", t('discussions', {
      count: f.discussions
    })), f.lastActivity ? m("span", null, m(Icon, {
      name: "far fa-clock"
    }), " ", t('active', {
      ago: humanTime(new Date(f.lastActivity))
    })) : null), f.latest.length ? m("div", {
      className: "FlarumverseForum-latest"
    }, m("span", {
      className: "FlarumverseForum-latestLabel"
    }, t('latest')), m("ul", null, f.latest.map(d => m("li", null, m("a", {
      href: d.url,
      rel: "noopener ugc"
    }, d.title))))) : null), m("div", {
      className: "FlarumverseForum-footer"
    }, m("a", {
      className: "Button Button--primary FlarumverseForum-visit",
      href: f.url,
      rel: "noopener ugc"
    }, t('visit')))))), this.loading ? m(LoadingIndicator, null) : null, this.more && !this.loading ? m("div", {
      className: "FlarumversePage-more"
    }, m(Button, {
      className: "Button",
      onclick: () => this.load(false)
    }, t('load_more'))) : null, m("p", {
      className: "FlarumverseDirectory-cta"
    }, t('list_yours')));
  }
}